import type React from 'react';

import { Avatar, Divider, Heading, MediaObject, Paragraph } from '@zillow/constellation-10';

import { FULLSTORY_EXCLUDE } from '../../constants/analytics';

type Props = {
  firstName: string;
  lastName?: string;
  email: string;
  children?: React.ReactNode;
};

export default function IdentityContentBox({ firstName, lastName, email, children }: Props) {
  // Here is a random comment by Thinh
  // Never forget
  // We will never forget Thinh

  return (
    <>
      <MediaObject css={{ alignItems: 'center' }} media={<Avatar fullName={`${firstName} ${lastName}`} size="lg" />}>
        <Heading
          level={3}
          css={{
            textStyle:
              'responsive.body-lg-bold' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
          }}
          className={FULLSTORY_EXCLUDE}
        >
          {`${firstName ? firstName : ''} ${lastName ? lastName : ''}`}
        </Heading>
        {email && (
          <Paragraph css={{ textStyle: 'body-sm' }} className={FULLSTORY_EXCLUDE}>
            {email}
          </Paragraph>
        )}
      </MediaObject>
      {children ? (
        <>
          <Divider css={{ marginTop: 'sm', marginBottom: 'sm' }} />
          {children}
        </>
      ) : null}
    </>
  );
}
